import React, { useState } from "react";

import PropTypes from "prop-types";

import Modal from "@shared/v2/Modal";
import TextComboInput from "@shared/v2/TextComboInput";
import Button from "@shared/v2/Button";
import { useContactPerson } from "../../reducers/contactsReducer/selectors";

const AddSubdomainModal = ({ show, onClose, onSave }) => {
  const person = useContactPerson();
  // const { domain } = person;

  const [subdomain, setSubdomain] = useState("");

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      contentClassName="tw-w-[616px] tw-flex tw-flex-col tw-gap-[32px]"
      show={show}
      onHide={onClose}
    >
      <Modal.Header
        className="tw-relative tw-text-gray-50"
        title="Add Subdomain"
        description="Subdomains can only be created for the main Brivity website. Changes may take up to 30 minutes to reflect on your Brivity website."
        closeButton
      />

      <Modal.Body className="tw-relative tw-flex tw-items-center tw-gap-4px tw-overflow-hidden">
        <TextComboInput
          label="Subdomain"
          value={subdomain}
          containerClassName="tw-flex-1 tw-flex tw-h-[84px]"
          onChange={(e) => setSubdomain(e.target.value)}
          error={subdomain.trim().length === 0 ? "This field is required" : null}
          isRequired
        />
        {person?.domain && <span className="tw-text-gray-50 tw-leading-[36px]">.{person?.domain}</span>}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between ">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="medium"
          disabled={subdomain.trim().length === 0}
          onClick={() => {
            onSave(subdomain);
            onClose();
          }}
          schema="primary"
        >
          ADD
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddSubdomainModal;

AddSubdomainModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

AddSubdomainModal.defaultProps = {
  show: false,
};
